import { Field, Form, Formik } from "formik";
import Title from "../../components/common/title/Title";
import {
  errorMessage,
  successMessage,
} from "../../utils/toastify-message/ToastifyMessage";
import { postApi, putApi } from "../../services/api/globalApi";
import Input from "../../components/common/inputs/Input";
import Button from "../../components/common/button/Button";
import { smsValidation } from "../../utils/validations/smsValidation";
import { useLocation, useNavigate } from "react-router";
import Select from "../../components/common/inputs/Select";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";

export default function SmsForm() {
  const location = useLocation();
  const navigate = useNavigate();

  const { utils } = useSelector(utilsState);
  const formHandler = async (values, { resetForm }) => {
    const body = {
      ...values,
    };
    try {
      if (location.state) {
        await putApi({
          path: `admin/sms/config/${location.state?._id}`,
          body: JSON.stringify(body),
        });
        successMessage("عملیات با موفقیت انجام بشد");
      } else {
        await postApi({
          path: "admin/sms/config",
          body: JSON.stringify(body),
        });
        successMessage("عملیات با موفقیت انجام بشد");
      }
      resetForm();
      navigate("/sms-list");
    } catch (error) {
      console.error(error);
      errorMessage(error?.response?.data?.errors[0].message);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"کانفیگ پنل پیامکی"} />
      <Formik
        enableReinitialize
        initialValues={{
          otpPatern: location?.state?.otpPatern || "",
          sendAcceptedOrderSmsPattern:
            location?.state?.sendAcceptedOrderSmsPattern || "",
          sendMultipleNumberSmsForArticlePattren:
            location?.state?.sendMultipleNumberSmsForArticlePattren || "",
          sendOrderBarcodesSmsPattren:
            location?.state?.sendOrderBarcodesSmsPattren || "",
          isDefault: location?.state?.isDefault || false,
          user: location?.state?.user || "",
          pass: location?.state?.pass || "",
          apiKey: location?.state?.apiKey || "",
          fromNum: location?.state?.fromNum || "",
          company:
            location?.state?.company ||
            utils?.SMS_COMPANY_VALUES[0]?.value ||
            "",
        }}
        validationSchema={smsValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="mt-6">
              <div className="grid gap-6 mb-4 md:grid-cols-2">
                {utils ? (
                  <Field
                    as="select"
                    name="company"
                    label="شرکت پیامک"
                    component={Select}
                  >
                    {utils?.SMS_COMPANY_VALUES.map((item) => {
                      return <option value={item.value}>{item?.name}</option>;
                    })}
                  </Field>
                ) : null}
                <Input
                  name="user"
                  placeholder="نام کاربری"
                  label="نام کاربری"
                  type="text"
                />
                <Input
                  name="pass"
                  placeholder="پسوورد"
                  label="پسوورد"
                  type="text"
                />
                <Input
                  name="apiKey"
                  placeholder="API Key"
                  label="API Key"
                  type="text"
                />
                <Input
                  name="fromNum"
                  placeholder="ارسال از خط"
                  label="ارسال از خط"
                  type="text"
                />
                <Input
                  name="otpPatern"
                  placeholder="پترن otp"
                  label="پترن otp"
                  type="text"
                />
                <Input
                  name="sendAcceptedOrderSmsPattern"
                  placeholder="پترن تایید سفارش"
                  label="پترن تایید سفارش"
                  type="text"
                />
                <Input
                  name="sendMultipleNumberSmsForArticlePattren"
                  placeholder="پترن ارسال مقاله  "
                  label="پترن ارسال مقاله  "
                  type="text"
                />

                <Input
                  name="sendOrderBarcodesSmsPattren"
                  placeholder="پترن دریافت بار کد"
                  label="پترن دریافت بار کد"
                  type="text"
                />

                <Select
                  name="isDefault"
                  value={formik.values["isDefault"] ? "true" : "false"}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "isDefault",
                      e.target.value === "true"
                    );
                  }}
                  placeholder="سامانه پیشفرض"
                  label="سامانه پیشفرض"
                >
                  <option value="true">بله</option>
                  <option value="false">خیر</option>
                </Select>
              </div>

              <div className="flex flex-col gap-y-2">
                <div className="mt-6">
                  <Button
                    text={location?.state ? "ویرایش" : "افزون"}
                    type={"success"}
                  />
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}
